import { type CustomerDTO } from "@ifa/utils";
import { CustomerProfileSection } from "../../CustomerDetail/components/profile/CustomerProfileSection";

interface PolicyholderViewProps {
  customer: CustomerDTO | null;
  onBack: () => void;
}

export function PolicyholderView({ customer }: PolicyholderViewProps) {
  return (
    <div style={{
      height: "100%",
      overflow: "auto",
    }}>
      <CustomerProfileSection
        customer={customer}
        policyholder={customer?.policyholder}
        mode="view"
        onSave={() => {}}
      />
    </div>
  );
}
